import React from "react";
import { Row, Space, Tooltip } from "antd";
import { GenericCard } from "../../common/components/GenericCard";
import { SvgIcon } from "../../common/components/SvgIcon";

export interface NegotiationInsightCardProps {
    label: string;
    tips: string;
    data: React.ReactNode;
    detail: React.ReactNode;
    onClick?: () => void;
}

export const NegotiationInsightCard: React.FC<NegotiationInsightCardProps> = ({
    label,
    tips,
    data,
    detail,
    onClick,
}) => (
    <GenericCard
        style={{
            cursor: "pointer",
            color: "#000000",
        }}
        onClick={onClick}
    >
        <Row>
            <Space>
                <span style={{ fontSize: 16 }}>{label}</span>
                <Tooltip title={tips}>
                    <SvgIcon name="help" size={12} color="#1890FF" />
                </Tooltip>
            </Space>
        </Row>
        <Row
            justify="center"
            style={{
                color: "#FF8400",
                fontSize: 28,
                fontWeight: 500,
            }}
        >
            {data}
        </Row>
        <Row justify="center" style={{ whiteSpace: "pre" }}>
            {detail}
        </Row>
    </GenericCard>
);
